window.addEventListener("load", function(){
    var cbid = getUrlVars()["cbid"];
    var pk = growsumo.data.partner_key;
    var l = document.links;
 
    for(var i=0; i<l.length; i++) {
    if (l[i].href.indexOf("planid=transaction-pro-importer-version-8-desktop") > -1 || l[i].href.indexOf("planid=importer-exporter-deleter-version-8-desktop") > -1){
        if (typeof pk !== 'undefined'){
               l[i].href = l[i].href + "&partnerkey=" + growsumo.data.partner_key;
            if (typeof cbid !== 'undefined' && cbid !== '{0}'){
                 l[i].href = l[i].href + "&cbid=" + cbid;
            };
        }
        else
        {
            if (typeof cbid !== 'undefined' && cbid !== '{0}'){
                 l[i].href = l[i].href + "&cbid=" + cbid;
            }
        }
    } 
   };
 });
 
 function getUrlVars() {
     var vars = {};
     var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
         vars[key] = value;
     });
     return vars;
 }